import { findNextItem } from '../utils';
/**
 * Represents the available `action` types for the `SchedulerItemsFocusAction` objects.
 *
 * The available types are:
 * - `ITEMS_FOCUS_NEXT`
 * - `ITEMS_FOCUS_PREV`
 */
export var ITEMS_FOCUS_ACTION;
(function (ITEMS_FOCUS_ACTION) {
    ITEMS_FOCUS_ACTION["next"] = "ITEMS_FOCUS_NEXT";
    ITEMS_FOCUS_ACTION["prev"] = "ITEMS_FOCUS_PREV";
})(ITEMS_FOCUS_ACTION || (ITEMS_FOCUS_ACTION = {}));
/** @hidden */
export var useItemsFocus = function (items) {
    var handleFocusedItemsAction = function (action, event) {
        switch (action.type) {
            case ITEMS_FOCUS_ACTION.next: {
                if (!action.item || !action.item.current || !items) {
                    return;
                }
                var next = findNextItem(action.item, items, action.ignoreIsAllDay, false);
                if (next && next.current && next.current.element) {
                    event.preventDefault();
                    next.current.element.focus();
                }
                break;
            }
            case ITEMS_FOCUS_ACTION.prev: {
                if (!action.item || !action.item.current || !items) {
                    return;
                }
                var next = findNextItem(action.item, items, action.ignoreIsAllDay, true);
                if (next && next.current && next.current.element) {
                    event.preventDefault();
                    next.current.element.focus();
                }
                break;
            }
            default:
                break;
        }
    };
    return [[], handleFocusedItemsAction];
};
//# sourceMappingURL=use-items-focus.js.map